import { Variants } from '@amplitude/experiment-js-client';

import { AppDispatch, AppGetState } from '@/redux/store';
import { hasGuideArticlesTreatment } from '@/utils/amplitude/experiments/hooks/useGuideArticles.experiment';

import { fetchArticleLinks } from './articleLinks.actions';
import { getArticleLinksNavigationId } from './articleLinks.selectors';
import { SearchArticleLinksParams } from './articleLinks.types';

type FetchArticleLinksIfCurrentParams = {
    amplitudeExperimentFlags: Variants;
    dispatch: AppDispatch;
    getState: AppGetState;
    navigationId: number;
    params: SearchArticleLinksParams | null | undefined;
};

/**
 * Fetches article links only when treatment is on and this navigation is still current.
 * Returns a resolved promise when skipped so callers can await or Promise.all freely.
 */
export const fetchArticleLinksIfCurrent = ({
    amplitudeExperimentFlags,
    dispatch,
    getState,
    navigationId,
    params,
}: FetchArticleLinksIfCurrentParams) => {
    if (!params || !hasGuideArticlesTreatment(amplitudeExperimentFlags)) {
        return Promise.resolve();
    }

    if (getArticleLinksNavigationId(getState()) !== navigationId) {
        return Promise.resolve();
    }

    return dispatch(fetchArticleLinks({ ...params, navigationId }));
};
